module.exports = __webpack_public_path__ + "static/media/swimming-pool.f422c37f.svg";